// extracted by mini-css-extract-plugin
export default {"point":"HealthPoint_point__NJ60e"};